module.exports = __webpack_public_path__ + "static/media/xepelin-horizontal.f5df3c97.svg";